export enum ProfileAuditDetails {
  COLUMN_NAME = 'columnName',
  FIELD_NAME = 'fieldName',
  NEW_VALUE = 'newValue',
  OLD_VALUE = 'oldValue'
}
